import { useTranslation } from '@/hooks/use-translation';
import { type Locale, supportedLngs } from '@/languages/i18n';

export const useLanguages = () => {
  const { i18n } = useTranslation();

  const setLocale = (locale: Locale) => {
    i18n.changeLanguage(locale);
    localStorage.setItem('allo:settings:locale', locale);
  };

  // Use i18n.language directly from useTranslation to ensure reactivity
  const locale = i18n.language as Locale;

  return { locale, setLocale, locales: supportedLngs };
};
